module.exports = __webpack_public_path__ + "static/media/tog.76bb481a.svg";